import { Data } from 'signup-constants/signupData/Data';
import { getCompanySizeOptionFromEmployeesRange } from '../company-info/companySize';
import { getSentryExtra } from '../error/getSentryExtra';
import { LOG } from '../http-complete-verification/handleCompleteVerificationError';
import { EndpointKey } from '../http/EndpointKey';
import { setEndpointTimeCompleted } from '../store/http-responses/action-creators';
import { getEndpointRetries } from '../store/http-responses/selectors';
import { bulkUpdate, bulkUpdateGtkmData, setSignupDataValue } from '../store/signup-data/action-creators';
import { Tracker } from '../store/tracking/action-creators';
import { getGTKMDomainToUse, getGTKMFallbackDomain } from './gtkmDomainUtils';
import { setNextSteps } from '../store/flow/action-creators';
import { Step } from 'signup-constants/Step';
import { FlowStateManager } from '../flow-management/FlowStateManager';
import { FlowActionTypes } from '../store/flow/action-types';
import { getCurrentStep, getPrevFlowStates } from '../store/flow/selectors';
export const updateFlowForGTKM = (state, dispatch, stepsToRemove) => {
  const currentStep = getCurrentStep(state);

  // Only move automatically to the next step if the current step is the loading page
  const shouldMoveToNextStep = currentStep === Step.LoadingPage;
  const newNextSteps = dispatch(FlowStateManager.removeSteps(stepsToRemove, shouldMoveToNextStep));
  if (!shouldMoveToNextStep) {
    dispatch(setNextSteps(newNextSteps));
  }

  // Remove loading page from previous flow states to prevent it being seen again
  const previousFlowStates = getPrevFlowStates(state);
  const updatedPreviousFlowStates = previousFlowStates.filter(flowStep => flowStep.completedStep !== Step.LoadingPage).map(flowStep => Object.assign({}, flowStep, {
    nextSteps: flowStep.nextSteps.filter(step => step !== Step.LoadingPage)
  }));
  dispatch({
    type: FlowActionTypes.UpdatePreviousFlowStates,
    previousFlowStates: updatedPreviousFlowStates
  });
};
export const handleACQ175GTKMCompanyInfoSuccess = ({
  domain,
  name,
  companySizeLowerBracket,
  companySizeUpperBracket,
  isFreeEmailDomain
}, dispatch, getState) => {
  const state = getState();
  dispatch(Tracker.signupInteraction('gtkm-company-info-prefill-success'));
  dispatch(Tracker.signupInteraction('gtkm-company-info-is-freemail', {
    currentValue: isFreeEmailDomain
  }));
  const gtkmDataWithoutDomain = {
    [Data.CompanySize]: companySizeLowerBracket && companySizeUpperBracket ? getCompanySizeOptionFromEmployeesRange({
      min: companySizeLowerBracket,
      max: companySizeUpperBracket
    }) : '',
    [Data.CompanyName]: name || ''
  };
  const gtkmData = Object.assign({}, gtkmDataWithoutDomain, {
    [Data.CompanyDomain]: domain || ''
  });
  dispatch(bulkUpdateGtkmData(gtkmData));
  dispatch(bulkUpdate(gtkmDataWithoutDomain));
  const retries = getEndpointRetries(state, EndpointKey.GTKMCompanyInfoACQ175);
  const returnedAllData = gtkmData[Data.CompanySize] && gtkmData[Data.CompanyName];
  const stepsToRemove = [...(returnedAllData ? [Step.CompanySize] : []), ...(returnedAllData ? [Step.CompanyName] : []), Step.LoadingPage];
  if (!isFreeEmailDomain && retries < 1) {
    dispatch(setSignupDataValue(Data.CompanyDomain, domain || ''));
    stepsToRemove.push(Step.CompanyDomain);
  }
  if (retries >= 1) {
    if (!returnedAllData) {
      stepsToRemove.push(Step.Review);
    }
  }
  updateFlowForGTKM(state, dispatch, stepsToRemove);
  dispatch(setEndpointTimeCompleted(EndpointKey.GTKMCompanyInfoACQ175, new Date()));
};
export const handleACQ175GTKMCompanyInfoError = (error, dispatch, getState) => {
  const state = getState();
  dispatch(Tracker.signupInteraction(`gtkm-industry-prefill-${error.status}`));
  dispatch(Tracker.signupInteraction(`gtkm-company-info-prefill-error-${error.status}`));
  const gtkmDomain = getGTKMDomainToUse(state);
  dispatch(bulkUpdateGtkmData({
    [Data.CompanyDomain]: gtkmDomain
  }));
  const retries = getEndpointRetries(state, EndpointKey.GTKMCompanyInfoACQ175);
  LOG.error('GTKM Company Information Request Failed', {
    extra: Object.assign({}, getSentryExtra(error), {
      gtkmDomain
    })
  });
  const stepsToRemove = [];
  if (retries < 1) {
    const fallbackDomain = getGTKMFallbackDomain(state);
    dispatch(setSignupDataValue(Data.CompanyDomain, fallbackDomain));
    // Remove loading page after first request as endpoint response is returned at this point
    stepsToRemove.push(Step.LoadingPage);
  }

  // Remove the review step if the endpoint fails on retry so user can input the correct data.
  if (retries >= 1) {
    stepsToRemove.push(Step.Review);
  }
  updateFlowForGTKM(state, dispatch, stepsToRemove);
};